import {calculateAvailableSeductionCells} from "./succubes/calculateAvailableSeductionCells";
import {isUnitFaction} from "./isUnitFaction";
import {FACTIONS} from "../../constants/factions";
import {SUCCUBES_SEDUCTION_COST} from "../../configs/factions/succubes";
import {hasAdjacentEnemyUnit} from "../gameState/hasAdjacentEnemyUnit";
import UNIT_TYPES from "../../configs/units";

export const checkIfSuccubesUnitCouldSeduce = (
  selectedUnit, units, playerCoins, hexes, specialBuildings, buildingsDamage, fortressesUnderConstruction
) => {
  if (!selectedUnit
    || !isUnitFaction(selectedUnit, FACTIONS.SUCCUBES)
    // Катапульты (D4) не соблазняют - см. calculateAvailableSeductionCells
    || selectedUnit.type === UNIT_TYPES.D4.id
    || selectedUnit.hasUsedAbilityThisWarPhase
    || playerCoins < SUCCUBES_SEDUCTION_COST
    || hasAdjacentEnemyUnit(selectedUnit.hexKey, selectedUnit.ownerId, units)
  ) {
    return false;
  }

  return calculateAvailableSeductionCells(
    hexes, units, selectedUnit, specialBuildings, buildingsDamage, fortressesUnderConstruction
  ).length > 0;
}
